import React from 'react';

// Styles & Assets
import styles from './TitlePollForm.module.css';


// Models
interface Props {
    children: React.ReactNode
    style?: React.CSSProperties
}

const TitlePollForm: React.FC<Props> = ({ children, style }) => {

    return (
        <p className={styles.inputTitle} style={style}>
            {children}
        </p>
    );
};

export default TitlePollForm;